import { supabaseRpc } from '@/lib/supabaseClient'
import type { Organization, UserRole } from '@/contexts/auth/types'

type BootstrapOrgRow = {
  id?: string
  organization_id?: string
  organizationId?: string
  name?: string
  organization_name?: string
  organizationName?: string
  tier?: Organization['tier']
  role: UserRole
  is_platform_admin?: boolean
  isPlatformAdmin?: boolean
  organization?: {
    id: string
    name: string
    tier: Organization['tier']
  }
}

export async function ensureOrgMembership(
  params: { clerkId: string; email: string; name: string; avatarUrl?: string },
): Promise<Organization> {
  const raw = await supabaseRpc<BootstrapOrgRow | BootstrapOrgRow[]>('bootstrap_current_user', {
    p_email: params.email,
    p_name: params.name,
    p_avatar_url: params.avatarUrl ?? null,
  })
  const data = Array.isArray(raw) ? raw[0] : raw

  const org = data?.organization
  const id = org?.id ?? data?.organization_id ?? data?.organizationId ?? data?.id
  const name = org?.name ?? data?.organization_name ?? data?.organizationName ?? data?.name
  const tier = org?.tier ?? data?.tier

  if (!data || !id || !name || !tier) {
    throw new Error('Failed to bootstrap user organization.')
  }

  return {
    id,
    name,
    tier,
    role: data.role,
    isPlatformAdmin: data.is_platform_admin ?? data.isPlatformAdmin ?? false,
  }
}
